import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Flex, Input, Select, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getManagers } from 'src/store/Slices/DropDownSlice'
import { deleteUser } from 'src/store/Slices/AuthSlice'

const DeleteUserModal = ({ visible, setVisible, onClickDelete, userInfo }) => {
  const dispatch = useDispatch()

  const usersList = useSelector(state => state.DropDownSlice.managersList)

  const [nextUserId, setNextUserId] = useState(null)

  const onClickDeleteUser = () => {
    dispatch(deleteUser({
      userId: userInfo.id,
      nextUserId
    })).then(() => {
      onClickDelete()
    })
  }

  return (
      <>
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"
    >
        <CModalHeader>
            <CModalTitle id="VerticallyCenteredExample">Удалить пользователя</CModalTitle>
        </CModalHeader>
        <CModalBody>
            <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                <>
                    <div>
                        <Typography.Title level={5}>Передать менеджеру</Typography.Title>
                        <Select
                            onClick={() => { dispatch(getManagers()) }}
                            style={{ width: '100%' }}
                            options={usersList?.data?.value.filter((manager) => manager.value != userInfo?.id)}
                            onChange={e => setNextUserId(e)}
                            value={nextUserId}
                            placeholder='Выбрать'
                            onSelect={(e, b) => {setNextUserId(e)}}
                        />
                    </div>
                </>
            </Flex>
        </CModalBody>
        <CModalFooter>
            <CButton color="secondary text-light" onClick={() => {setVisible(false)}}>
                Закрыть
            </CButton>
            <CButton color="primary text-light" onClick={onClickDeleteUser}>Удалить</CButton>
        </CModalFooter>
    </CModal>
  </>
  )
}

export default DeleteUserModal